import React, { useContext, useState, Fragment } from "react";
import clsx from "clsx";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Edit, Delete, Add, Settings, Remove } from "@material-ui/icons";
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Grid,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import moment from "moment";
import { IProject } from "../../interface/project";
import { MainContext } from "../../context/main";
import { useHistory } from "react-router-dom";
import { LangContext } from "../../context/lang";

interface IRowTable {
  data: IProject;
  users: any[];
  clickDelete: Function;
  changeResponsiblePerson: Function;
  process: boolean;
  confirmAssign: Function;
  departments: any[];
}

const useStyle = makeStyles((theme: Theme) => ({
  removeBorderBottom: { borderBottom: "unset" },
  searchBtn: { textTransform: "unset" },
  inprocessText: { fontWeight: 600, color: theme.palette.warning.main },
  completeText: { fontWeight: 600, color: theme.palette.success.main },
  removeIcon: { color: theme.palette.error.main },
}));

const ProjectRowTable = (props: IRowTable) => {
  const classes = useStyle();
  const { userInfo } = useContext(MainContext);
  const { lang } = useContext(LangContext);
  const history = useHistory();

  const [open, setOpen] = useState<boolean>(false);
  const { data } = props;

  const checkPermission = (role: string | undefined) =>
    role !== "customer" ? true : false;

  return (
    <Fragment>
      <TableRow key={data.work_order_no}>
        {checkPermission(userInfo?.role) && (
          <TableCell
            align="center"
            style={{ width: 100 }}
            className={classes.removeBorderBottom}
          >
            <IconButton
              size="small"
              onClick={() => {
                setOpen(!open);
              }}
            >
              {open ? <Remove /> : <Add />}
            </IconButton>
          </TableCell>
        )}
        <TableCell
          align="center"
          style={{ width: 180 }}
          className={clsx(
            checkPermission(userInfo?.role) && classes.removeBorderBottom
          )}
        >
          {data.work_order_no}
        </TableCell>
        <TableCell
          className={clsx(
            checkPermission(userInfo?.role) && classes.removeBorderBottom
          )}
        >
          {data.customer_name}
        </TableCell>
        <TableCell
          align="center"
          className={clsx(
            checkPermission(userInfo?.role) && classes.removeBorderBottom
          )}
        >
          {data.created_at
            ? moment(data.created_at).format("DD/MM/YYYY") //new Date(data.created_at).toLocaleDateString()
            : ""}
        </TableCell>
        <TableCell
          align="center"
          className={clsx(
            checkPermission(userInfo?.role) && classes.removeBorderBottom,
            data.status === 2 && classes.completeText,
            data.status === 1 && classes.inprocessText
          )}
        >
          {data.status === 2
            ? lang.data.complete
            : data.status === 1
            ? lang.data.inProcess
            : lang.data.waitting}
        </TableCell>
        <TableCell
          align="center"
          className={clsx(
            checkPermission(userInfo?.role) && classes.removeBorderBottom
          )}
        >
          <IconButton
            size="small"
            onClick={(e: any) => {
              const departmentName = props.departments.find(
                (dp: any) => dp._id === data.department_id
              ).name;
              const dataAddDepartmentName = {
                ...data,
                department_name: departmentName,
              };
              history.push(
                "/app/design/project-drawing",
                JSON.stringify(dataAddDepartmentName)
              );
            }}
          >
            <Edit />
          </IconButton>
          <IconButton
            size="small"
            onClick={(e: any) => {
              history.push("/app/design/project-detail", JSON.stringify(data));
            }}
          >
            <Settings />
          </IconButton>
          <IconButton
            size="small"
            className={classes.removeIcon}
            onClick={() => {
              props.clickDelete(data._id);
            }}
          >
            <Delete />
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        {checkPermission(userInfo?.role) && (
          <Fragment>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} />
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Grid container spacing={1} style={{ margin: 8 }}>
                  <Grid item xs={4}>
                    <Select
                      variant="outlined"
                      fullWidth
                      margin="dense"
                      value={
                        data.responsible_person ? data.responsible_person : ""
                      }
                      onChange={(
                        event: React.ChangeEvent<{
                          name?: string;
                          value: unknown;
                        }>
                      ) => {
                        props.changeResponsiblePerson(
                          data._id,
                          event.target.value
                        );
                      }}
                    >
                      {props.users
                        .filter(
                          (u: any) =>
                            u.mea &&
                            u.mea.department_id &&
                            u.role === "officer" &&
                            u.mea.department_id === data.department_id
                        )
                        .sort(function (a, b) {
                          var nameA = a.first_name.toLowerCase(); // ignore upper and lowercase
                          var nameB = b.first_name.toLowerCase(); // ignore upper and lowercase
                          if (nameA < nameB) {
                            return -1;
                          }
                          if (nameA > nameB) {
                            return 1;
                          }

                          // names must be equal
                          return 0;
                        })
                        .map((user: any) => {
                          return (
                            <MenuItem key={user._id} value={user._id}>
                              {`${user.first_name}  ${user.last_name}`}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.searchBtn}
                      disabled={
                        props.process || !Boolean(data.responsible_person)
                      }
                      onClick={() => {
                        props.confirmAssign(data._id);
                      }}
                    >
                      {lang.data.confirm}
                    </Button>
                  </Grid>
                </Grid>
              </Collapse>
            </TableCell>
          </Fragment>
        )}
      </TableRow>
    </Fragment>
  );
};

export default ProjectRowTable;
